import { supabase } from './supabase';

/**
 * A page's offers for the creator dashboard, contact_email included, through
 * get_dashboard_service_offerings(): page owner or staff only, ordered by
 * display_order. contact_email (the creator's private sponsorship address)
 * is not in the table grants, so a direct select('*') no longer works.
 *
 * One call returns whole rows, so an offer can never arrive without its
 * email. Callers must treat an error as "offers failed to load", never as
 * "no offers": an empty editor would let the next save overwrite real data.
 */
export async function loadDashboardServiceOfferings(
  talentId: string
): Promise<{ data: any[] | null; error: { message: string } | null }> {
  const { data, error } = await supabase.rpc('get_dashboard_service_offerings', { p_talent_id: talentId });
  if (error) return { data: null, error };
  return { data: (data ?? []) as any[], error: null };
}
